<a [href]="link" target="_blank" title="Acesse o Boleto clicando aqui" class="btn-one btn-icon">
  <i class="material-icons">&#xE873;</i>
  <span>BOLETO ATIVIDADE</span>
</a>
